import type {LinkedIssuePullRequest} from './types'

export function getTaskStateLabel(state: string, pullRequest: LinkedIssuePullRequest | null): string {
  if (state === 'waiting_for_user') return 'Needs input'
  if (state === 'completed') {
    if (!pullRequest) return 'Completed'

    if (pullRequest.state === 'OPEN') return 'Ready for review'
    if (pullRequest.state === 'MERGED') return 'Merged'
    if (pullRequest.state === 'CLOSED') return 'Closed'

    return 'Completed'
  }
  if (state === 'failed' || state === 'timed_out') return 'Failed'
  return 'In progress'
}
